import { CategorySchema } from 'openapi'
import { CategoryWithChildren } from 'features/categories/interfaces'

export const createCategoriesTree = (
  categories: CategorySchema[],
  allowEmptyCategories: boolean,
  parent?: number | null
): CategoryWithChildren[] => {
  categories = categories.sort((a, b) => a.order - b.order)
  const rootCategories: CategorySchema[] = categories.filter((category) =>
    parent ? category.parent_id === parent : !category.parent_id
  )
  const categoriesWithChildren: CategoryWithChildren[] = rootCategories.map((category) => {
    const children = createCategoriesTree(categories, allowEmptyCategories, category.id)
    const childrenSum = children.reduce((sum, child) => sum + child.softwareCount, 0)
    return {
      ...category,
      children,
      softwareCount: (category.softwareCount ?? 0) + childrenSum,
    }
  })
  if (allowEmptyCategories) return categoriesWithChildren
  return categoriesWithChildren.filter((category) => category.children.length > 0 || category.softwareCount > 0)
}
